export default __webpack_public_path__ + "static/media/coin_usd.55e872d5.svg";